// Default theme values from COLOUR_SCHEME.md.
//
// These mirror the defaults seeded into the company_theme table by the
// server's migration `019_create_company_theme.sql`. The same map is used
// as the fallback when /api/v1/company/theme fails to load.

import type { CompanyTheme } from '../types/api';

export const DEFAULT_THEME: CompanyTheme = {
  // Brand
  color_primary: '#0f172a',
  color_primary_hover: '#1e293b',
  color_primary_light: '#162236',
  color_secondary: '#2563eb',

  // Navigation
  color_nav_bg: '#0f172a',
  color_nav_text: '#b3c0d1',
  color_nav_text_muted: '#64748b',
  color_nav_active_bg: '#162236',
  color_nav_active_text: '#e2e8f0',
  color_nav_hover_bg: '#1e293b',
  color_nav_border: '#1e293b',

  // Subheader
  color_subheader_bg: '#ffffff',
  color_subheader_text: '#0f172a',
  color_subheader_border: '#e2e8f0',

  // Page surfaces
  color_page_bg: '#f8fafc',
  color_card_bg: '#ffffff',
  color_card_border: '#e2e8f0',
  color_table_header_bg: '#f8fafc',
  color_table_row_hover: '#f1f5f9',
  color_table_border: '#e2e8f0',

  // Status badges — booking
  color_status_pending_bg: '#fef3c7',
  color_status_pending_text: '#92400e',
  color_status_confirmed_bg: '#dbeafe',
  color_status_confirmed_text: '#1e40af',
  color_status_completed_bg: '#dcfce7',
  color_status_completed_text: '#166534',
  color_status_cancelled_bg: '#f3f4f6',
  color_status_cancelled_text: '#6b7280',
  color_status_cancel_req_bg: '#fee2e2',
  color_status_cancel_req_text: '#991b1b',

  // Status badges — payment / collection
  color_status_paid_bg: '#d1fae5',
  color_status_paid_text: '#065f46',
  color_status_unpaid_bg: '#fee2e2',
  color_status_unpaid_text: '#991b1b',
  color_status_collected_bg: '#d1fae5',
  color_status_collected_text: '#065f46',
  color_status_awaiting_bg: '#e0f2fe',
  color_status_awaiting_text: '#0369a1',

  // Buttons
  color_btn_primary_bg: '#0f172a',
  color_btn_primary_text: '#ffffff',
  color_btn_secondary_bg: '#f8fafc',
  color_btn_secondary_text: '#0f172a',
  color_btn_success_bg: '#10b981',
  color_btn_success_text: '#ffffff',
  color_btn_danger_bg: '#ef4444',
  color_btn_danger_text: '#ffffff',
  color_btn_warning_bg: '#f59e0b',
  color_btn_warning_text: '#ffffff',
  color_btn_info_bg: '#06b6d4',
  color_btn_info_text: '#ffffff',

  // Text
  color_text_primary: '#0f172a',
  color_text_secondary: '#475569',
  color_text_muted: '#94a3b8',

  // Borders & inputs
  color_border: '#e2e8f0',
  color_input_bg: '#ffffff',
  color_input_border: '#cbd5e1',
  color_input_border_focus: '#2563eb',
};
